export default "__VITE_ASSET__TAO2Si18__"